import React from 'react'
import styled from '~/app/components/styled'
import { Renderable } from './index'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * TitleDescription component
 * author: soojin.oh
 */

// type definitions
export type TitleDescriptionProps = {
  title: Renderable
  description: Renderable
  subDescription?: Renderable
  icon?: Renderable
  iconDescription?: Renderable // icon 클릭시 노출되는 내용
}

// styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 1.2rem;
  align-items: center;
  padding: 0.8rem 2rem;
  ${Typography('body1').regular};
`
const Title = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.gray600};
`
const Description = styled.div`
  text-align: right;
  color: ${({ theme }) => theme.color.gray900};
  word-break: break-all;
`
const SubDescription = styled.div`
  grid-column: 1 / 3;
  width: 100%;
  text-align: end;
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray600};
  margin-top: 0.6rem;
`
const Icon = styled.span`
  width: 1.4rem;
  height: 1.4rem;
  margin-left: 0.2rem;
  margin-top: -0.1rem;
  cursor: pointer;
`

// TitleDescription component
const TitleDescription: React.FunctionComponent<TitleDescriptionProps> = function ({
  title,
  description,
  subDescription,
  icon,
  iconDescription,
}) {
  return (
    <Container>
      <Title>
        {title}
        {icon && <Icon>{icon}</Icon>}
      </Title>
      {iconDescription}
      <Description>{description}</Description>
      {subDescription && <SubDescription>{subDescription}</SubDescription>}
    </Container>
  )
}

export default TitleDescription
